const isSchoolEmail = (string, array_of_campus_exts) => {

    // Join the array of extensions into a single string, separated by '|'
    let extensions = array_of_campus_exts.join('|');

    // Regular expression to match emails with domains ending in any of the provided extensions
    // The dollar sign ($) ensures the match occurs at the end of the string, preventing partial matches
    let regex = new RegExp(`[a-z0-9]+@(${extensions})$`);

    // Test if the provided string matches the defined email pattern
    return regex.test(string);
}

export default isSchoolEmail;